export enum ClosedPeriodScope {
  StudioWide = "StudioWide",
  PerMember = "PerMember",
}
